import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    outline: ", " solid ", ";\n    outline-offset: -", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { row } from '../theme';
var outlineWidth = '2px';
export var TableBodyRow = styled.tr(_templateObject(), function (_ref) {
  var isHighlighted = _ref.isHighlighted;
  return isHighlighted && css(_templateObject2(), row.highlightedBackground);
}, function (_ref2) {
  var isHighlighted = _ref2.isHighlighted;
  return css(_templateObject3(), isHighlighted ? row.hoverHighlightedBackground : row.hoverBackground);
}, outlineWidth, row.focusOutline, outlineWidth);